/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useCallback, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import { MdAdd, MdEdit, MdDeleteForever } from 'react-icons/md';

import Table from 'components/Table';
import FullLoader from 'components/FullLoader';
import Pagination from 'components/Pagination';
import { modalStyle } from 'components/ModalStyle';

import { PackagesProps } from 'interfaces/packages';
import { useUsers } from 'hooks/users';
import api from 'services/api';

import { toast } from 'react-toastify';
import AddPackageModal from './AddPackageModal';
import EditPackageModal from './EditPackageModal';
import { Container } from './styles';

const Packages: React.FC = () => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [packages, setPackages] = useState<PackagesProps[]>([]);
  const [selectedPackage, setSelectedPackage] = useState<PackagesProps>(
    {} as PackagesProps
  );
  const dispatch = useDispatch();

  const { count = 0, users = [] } = useUsers();

  const handleItemsPerPageChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(e.target.value));
    setPage(1);
  };

  const handleNextPage = React.useCallback(() => {
    setPage((prev) => prev + 1);
  }, []);

  const handlePreviousPage = React.useCallback(() => {
    setPage((prev) => prev - 1);
  }, []);

  useEffect(() => {
    api.get(`/payers/findAllPackages`).then((response) => {
      setPackages(response.data);
      setLoading(false);
    });
  }, [page, itemsPerPage, dispatch]);

  const handleOpenEditModal = useCallback((item: PackagesProps) => {
    setSelectedPackage(item);
    setEditModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    api.get(`/payers/findAllPackages`).then((response) => {
      setPackages(response.data);
      setAddModalOpen(false);
      setEditModalOpen(false);
    });
  }, []);

  const handleDeletePackage = useCallback((id: string) => {
    const result = window.confirm('Deseja realmente apagar este pacote?');
    if (result) {
      api.delete(`/payers/deletePackage?id=${id}`).then((response) => {
        toast.success('Pacote apagado com sucesso!');
        api.get(`/payers/findAllPackages`).then((response2) => {
          setPackages(response2.data);
        });
      });
    }
  }, []);

  return (
    <Container>
      <FullLoader show={loading} />
      <button
        onClick={() => setAddModalOpen(true)}
        className="addPackageButton"
        type="button"
      >
        <MdAdd size={20} color="#fff" />
        <span>Adicionar pacote</span>
      </button>
      <div className="table-container">
        <Table>
          <thead>
            <tr>
              <th align="left">Quantidade</th>
              <th align="left">Preço</th>
              <th align="left">Editar</th>
              <th align="left">Excluir</th>
            </tr>
          </thead>
          <tbody>
            {packages?.map((item, index) => (
              <tr key={index}>
                <td>
                  <p>{item?.amount}</p>
                </td>
                <td>{`R$ ${String(item?.price).replace('.', ',')}`}</td>
                <td>
                  <button
                    type="button"
                    onClick={() => handleOpenEditModal(item)}
                  >
                    <MdEdit color="#286738" size={20} />
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    onClick={() => handleDeletePackage(item.id)}
                  >
                    <MdDeleteForever color="#cc0000" size={20} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="pagination-container">
          <div className="pagination-options">
            <p>Itens por página</p>
            <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div className="pagination">
            <Pagination
              offset={(page - 1) * itemsPerPage}
              currentCount={users?.length}
              total={count}
              handlePreviousPage={handlePreviousPage}
              handleNextPage={handleNextPage}
            />
          </div>
        </div>
      </div>
      <Modal isOpen={addModalOpen} style={modalStyle}>
        <AddPackageModal closeModal={() => handleCloseModal()} />
      </Modal>
      <Modal isOpen={editModalOpen} style={modalStyle}>
        <EditPackageModal
          initialData={selectedPackage}
          closeModal={() => handleCloseModal()}
        />
      </Modal>
    </Container>
  );
};

export default Packages;
